<template>
  <v-card
    class="d-flex eq-height eq-width flex-column flex-nowrap pa-2"
  >
    <div class="d-flex flex-nowrap justify-space-between mx-3 mt-3">
      <div
        class="d-flex"
      >
        <div
          class="secondary--text font-weight-bold align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
        >
          Mon prix d'équilibre
        </div>
      </div>
      <div
        class="align-self-center ml-3"
      >
        <v-icon
          @click="isOpenModalHelp = true"
        >
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <BaseLoader v-if="isAbonneCulturial && loading.repartitionAdherent && !erreur.repartitionAdherent" />
    <div v-else>
      <div
        v-if="resumePrixEquilibre == null || (resumePrixEquilibre != null && resumePrixEquilibre.prixEquilibreEnEuroParTonne == null) || !isAbonneCulturial || !hasClotureVerrouillee || erreur.repartitionAdherent"
        class="mb-2"
      >
        <div
          class="d-flex
        align-center
        flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        >
          <img
            src="@/assets/info-abonnement/info-abonnement.svg"
            alt="info-abonnement"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-2"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          >
            <span>Suivez vos performances et détectez vos leviers d’améliorations</span>
          </div>
        </div>
      </div>  
      <v-row
        v-if="resumePrixEquilibre == null || (resumePrixEquilibre != null && resumePrixEquilibre.prixEquilibreEnEuroParTonne == null) || !isAbonneCulturial || !hasClotureVerrouillee"
        no-gutters
        class="mt-auto pt-3 mb-5 mx-5"
      >
        <v-col
          class="px-1"
          cols="12"
        >
          <AgrButton
            elevation="0"
            block
            large
            @click="onClickInformationAbonnement"
          >
            <v-icon
              v-if="!isAbonneCulturial"
              class="align-self-center mr-3"
              size="18"
              color="secondary"
            >
              mdi-lock
            </v-icon>
            <span class="action text-truncate white--text">
              Voir mes coûts</span>
          </AgrButton>
        </v-col>
      </v-row>
      <v-row
        v-if="resumePrixEquilibre!= null && resumePrixEquilibre.prixEquilibreEnEuroParTonne != null && isAbonneCulturial && hasClotureVerrouillee && !erreur.repartitionAdherent"
        justify="center"
        class="mb-5"
      >
        <v-col
          cols="12"
          md="5"
          offset-md="1"
          align="center"
          class="align-self-center"
        >
          <PercentageDoughnut
            :data="{
              percentage: resumePrixEquilibre.ratioChargesFixesEnPourcentage >= 100 ? 99.99 : resumePrixEquilibre.ratioChargesFixesEnPourcentage,
              value: resumePrixEquilibre.ratioChargesFixesEnPourcentage
            }"
            :tooltip="false"
            empty-color="var(--branche)"
            size="240"
            width="20"
            positive-color="#dbbd00"
            negative-color="#ec6608"
          >
            <div
              class="d-flex align-self-center flex-column align-center"
            >
              <div class="d-flex">
                <div class="chiffre-xxl secondary--text align-self-center">
                  {{ resumePrixEquilibre.prixEquilibreEnEuroParTonne |roundNumber(0) }}
                </div>
                <div class="titre-h1 secondary--text align-self-center ml-2">
                  €/t
                </div>
              </div>
              <div
                class="align-self-center"
                :class="$vuetify.breakpoint.mobile ? 'mt-3' : ''"
              >
                <BaseEvolutionWithInfo
                  :evolution-value="resumePrixEquilibre.evolutionPrixEquilibreEnPourcentage"
                  :values="resumePrixEquilibre.prixEquilibreParAnnee"
                  :unite="'€/t'"
                />
              </div>
            </div>
          </PercentageDoughnut>
        </v-col>
        <v-col
          cols="12"
          md="5"
          align="center"
          class="align-self-center"
        >
          <div class="d-flex texte texte-gris-fonce">
            <v-chip
              label
              class="eq-width-chip"
              color="var(--branche)"
            >
              <span
                class="action white--text"
              >
                {{ resumePrixEquilibre.ratioChargesVariablesEnPourcentage | roundNumber(0) }} %
              </span>
            </v-chip>
            <span class="texte texte-gris-fonce pt-2 ml-2">
              Charges variables
            </span>
          </div>
          <div class="d-flex pt-2 texte texte-gris-fonce">
            <v-chip
              label
              class="eq-width-chip"
              color="#DBBD00"
            >
              <span
                class="action white--text align-center"
              >
                {{ resumePrixEquilibre.ratioChargesFixesEnPourcentage | roundNumber(0) }} %
              </span>
            </v-chip>
            <span class="texte texte-gris-fonce pt-2 ml-2">
              Charges fixes
            </span>
          </div>
        </v-col>
      </v-row>
      <div
        v-if="resumePrixEquilibre!= null && resumePrixEquilibre.prixEquilibreEnEuroParTonne != null && isAbonneCulturial && hasClotureVerrouillee"
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'mr-16' : ''"
      >
        <div
          v-if="!erreur.repartitionGroupe"
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mr-2' : 'position-indicateur-jauge'"
        >
          <UserIndicatorJauge
            :chargement="loading.repartitionGroupe"
            :data="{
              value: positionJaugeGroupe(resumePrixEquilibreGroupe?.codePositionDuNumtiers)
            }"
            :unite="'€/t'"
            :data-groupe="resumePrixEquilibreGroupe?.valeurMoyenneDuGroupe"
            :negative-color="resumePrixEquilibreGroupe?.valeurMoyenneDuGroupe ? '#ec6608' : 'grey'"
            :positive-color="resumePrixEquilibreGroupe?.valeurMoyenneDuGroupe ? '#01713c' : 'grey'"
          />
        </div>
        <AgrButton
          color="primary"
          large
          :block="$vuetify.breakpoint.mobile"
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? '' : ' position-btn-plus-infos'"
          @click="openModaleDetail"
        >
          <v-icon>mdi-magnify-plus-outline</v-icon>
          <span class="action text-truncate white--text">Plus d'infos</span>
        </AgrButton>
      </div>
    </div>
    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      code-feature="PRIX_EQUILIBRE_CULTURE"
      texte="Déterminez votre prix d'équilibre par culture en €/t grâce à un expert, pour vous aider dans votre commercialisation."
      titre="Mesurer la rentabilité technique et économique"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalAideInformationAbonnement = false"
    />
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Mon prix d'équilibre"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-4">
          <p>
            L'indicateur affiché correspond à votre prix d'équilibre, rémunération comprise et aides PAC et co-produits déduits. 
          </p>
          <p class="pt-1">
            Le détail de chaque poste ainsi que la formule sont indiqués en cliquant sur le bouton "Plus d'infos".
          </p>
        </div>
      </div>
    </HelpModal>
    <DetailPrixEquilibreModal
      v-if="isOpenModalDetail"
      :is-open-modal="isOpenModalDetail"
      :code-type-culture="codeGraineCulturialSelected"
      @close="isOpenModalDetail = false"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import DetailPrixEquilibreModal from './modal/detail-prix-equilibre-modal.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import PercentageDoughnut from '@/components/chart/v2/percentage-doughnut.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'

export default {
  name: 'PrixEquilibre',
  components: { AgrButton, BaseEvolutionWithInfo, BaseLoader, DetailPrixEquilibreModal, HelpModal, InformationAbonnementModal, PercentageDoughnut, UserIndicatorJauge },
  props: {
    codeGraineCulturialSelected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      isOpenModalAideInformationAbonnement: false,
      isOpenModalDetail: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false,
        repartitionGroupe: false
      }
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage',
      resumePrixEquilibre: 'cloture/resumePrixEquilibre',
      resumePrixEquilibreGroupe: 'cloture/resumePrixEquilibreGroupe'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    }
  },
    watch: {
    codeGraineCulturialSelected () {
      this.loadDonneesAdherent()
    },
    anneeRecolteSelected () {
      this.loadDonneesAdherent()
    }
  },
  created () {
    this.loadDonneesAdherent()
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      getResumePrixEquilibre: 'cloture/getResumePrixEquilibre',
      getResumePrixEquilibreGroupe: 'cloture/getResumePrixEquilibreGroupe'
    }),

    loadDonneesAdherent () {
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getResumePrixEquilibre(this.codeGraineCulturialSelected)
        .then(() => {
          this.loadResumePrixEquilibreGroupe()
        })
        .catch(() => this.erreur.repartitionAdherent = true)
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadResumePrixEquilibreGroupe () {
      this.loading.repartitionGroupe = true
      this.erreur.repartitionGroupe = false
      const params = {
        codeGraine: this.codeGraineCulturialSelected,
        anneeRecolte: this.anneeRecolteSelected,
        filtres: this.filtresAdherent
      }
      this.getResumePrixEquilibreGroupe(params)
        .catch(() => {
          this.erreur.repartitionGroupe = true
        })
        .finally(() => {
          this.loading.repartitionGroupe = false
        })
    },
    
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('PRIX_EQUILIBRE_CULTURE')
    },
    openModaleDetail () {
      this.isOpenModalDetail = true
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    }
  }
}

</script>
<style lang="scss" scoped>

.positif-color {
  color: #dbbd00;
}

.position-indicateur-jauge {
  position: absolute;
  bottom: 18px;
  right: 180px;
}
.position-btn-plus-infos {
  position: absolute;
  bottom: 28px;
  right: 15px;
}

.asterix {
  font-size: 0.875rem;
  color: var(--grey-dark);
}
.eq-width-chip {
  width: 54px;
}
</style>